// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5eb76975] .v-pagination {\n  justify-content: flex-end;\n}\n[data-v-5eb76975] .v-skeleton-loader__list-item-three-line {\n  height: 54px;\n  width: 80%;\n}\n[data-v-5eb76975] .v-skeleton-loader__button {\n  width: 110px;\n  height: 32px;\n  border-radius: 16px;\n}", ""]);
// Exports
module.exports = exports;
